import { lightTheme } from '@/customTheme'
import { LayoutUtils } from '@/utils/LayoutUtils'
import { styled } from 'baseui'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Z_INDEX } from '@/constants/z-index'

const WrapTooltip = styled('div', ({ $theme }) => ({
  width: '280px',
  height: '120px',
  background: '#52B5E0',
  borderRadius: '16px',
  position: 'fixed',
  top: `calc(${LayoutUtils.NAVBAR_HEIGHT + 4}px)`,
  right: '251px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  opacity: 0,
  zIndex: Z_INDEX.TOOLTIP_CONFIRM,
  animationName: {
    from: {
      opacity: 0,
      transform: 'translateY(25px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
  animationDuration: '0.3s',
  animationTimingFunction: 'ease-out',
  animationFillMode: 'forwards',
  animationDelay: '2s',
}))

const ChevronTop = styled('span', ({ $theme }) => ({
  position: 'absolute',
  top: '-12px',
  right: '25px',
  width: 0,
  height: 0,
  borderLeftWidth: '12px',
  borderRightWidth: '12px',
  borderTopWidth: '0',
  borderBottomWidth: '12px',
  borderLeftColor: 'transparent',
  borderRightColor: 'transparent',
  borderBottomColor: '#52B5E0',
  borderStyle: 'solid',
}))

const WrapGotItBtn = styled('span', ({ $theme }) => ({
  marginLeft: 'auto',
  width: '75px',
  height: '100%',
  borderRadius: '360px',
  background: lightTheme.colors.white,
  ...lightTheme.typography.Small16Bold,
  fontWeight: 600,
  color: '#52B5E0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  ':hover': {
    background: lightTheme.colors.grayScale20,
  },
  ':active': {
    background: lightTheme.colors.grayScale50,
  },
}))
function TooltipConfirm({ setShowTooltip }) {
  const [t] = useTranslation()

  useEffect(() => {
    const handleClick = (e: any) => {
      if (!e.target.closest('#tooltip-confirm')) {
        setShowTooltip(false)
      }
    }
    
    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])
  return (
    <WrapTooltip id="tooltip-confirm">
      <p
        style={{
          ...lightTheme.typography.Small16Bold,
          fontWeight: 600,
          color: lightTheme.colors.white,
        }}
      >
        {t("Don't love it? Click Undo.")}
      </p>
      <WrapGotItBtn onClick={() => setShowTooltip(false)}>{t('Got it!')}</WrapGotItBtn>
      <ChevronTop />
    </WrapTooltip>
  )
}

export default TooltipConfirm
